import PropTypes from "prop-types";
import StepProgreassBar from "./StepProgressBar";
import { useContext } from "react";
import { AppContext } from "../util/AppContext";
import { getConfigValue, isBatchPrintEnabledForAnyProduct } from "../util/getConfigValue";
import { focusTypeName } from "../util/constants";

CreateSalesAidStepProgressBar.propTypes = {
    currentStepId: PropTypes.string,
    focusType: PropTypes.string
}

export const SalesAidStepIds = Object.freeze({
    SELECTPRIMARYFOCUS: "selectPrimaryFocus",
    SELECTTERRITORY: "selectTerritory",
    SELECTTARGET: "selectTarget",
    CONFIGUREMESSAGE: "configureMessage",
    GENERATEDOCUMENT: "generateDocument",
    COMPLETED: "completed"
});

function CreateSalesAidStepProgressBar({ currentStepId, focusType }) {
    const [appState] = useContext(AppContext);
    const batchPrintEnabled = isBatchPrintEnabledForAnyProduct(appState);
    const focusTypeLabel = focusType === undefined ? "" : ` - ${focusType}`

    const stepsOrder = focusType === focusTypeName.HCPs || focusType === undefined ? [
        SalesAidStepIds.SELECTPRIMARYFOCUS,
        SalesAidStepIds.SELECTTERRITORY,
        SalesAidStepIds.SELECTTARGET,
        SalesAidStepIds.CONFIGUREMESSAGE,
        SalesAidStepIds.GENERATEDOCUMENT,
        SalesAidStepIds.COMPLETED
    ] : 
    [
        SalesAidStepIds.SELECTPRIMARYFOCUS,
        SalesAidStepIds.SELECTTERRITORY,
        SalesAidStepIds.CONFIGUREMESSAGE,
        SalesAidStepIds.SELECTTARGET,    
        SalesAidStepIds.GENERATEDOCUMENT,
        SalesAidStepIds.COMPLETED
    ];

    const steps =[
        {
            id: SalesAidStepIds.SELECTPRIMARYFOCUS,
            label: `${getConfigValue(appState.config?.Focus?.BreadCrumb?.PrimaryFocus?.Label, appState)?.Value || null}${focusTypeLabel}`,
            current: isCurrent(SalesAidStepIds.SELECTPRIMARYFOCUS),
            completed: isCompleted(SalesAidStepIds.SELECTPRIMARYFOCUS),
            path: isCompleted(SalesAidStepIds.SELECTPRIMARYFOCUS) ? "/FocusPage" : "",
            disabled: !batchPrintEnabled
        },
        {
            id: SalesAidStepIds.SELECTTERRITORY,
            label: getConfigValue(appState.config?.Focus?.BreadCrumb?.Territory?.Label, appState)?.Value || null,
            current: isCurrent(SalesAidStepIds.SELECTTERRITORY),
            completed: isCompleted(SalesAidStepIds.SELECTTERRITORY),
            path: isCompleted(SalesAidStepIds.SELECTTERRITORY) ? "/TerritoryPage" : "",
            disabled: appState?.bypassTerritorySelection
        },
        {
            id: SalesAidStepIds.SELECTTARGET,
            label: getConfigValue(appState.config?.Focus?.BreadCrumb?.Target?.Label, appState)?.Value || null,
            current: isCurrent(SalesAidStepIds.SELECTTARGET),
            completed: isCompleted(SalesAidStepIds.SELECTTARGET),
            path: isCompleted(SalesAidStepIds.SELECTTARGET) ? "/HCPPage" : ""
        },
        {
            id: SalesAidStepIds.CONFIGUREMESSAGE,
            label: getConfigValue(appState.config?.Focus?.BreadCrumb?.Configure?.Label, appState)?.Value || null,
            current: isCurrent(SalesAidStepIds.CONFIGUREMESSAGE),
            completed: isCompleted(SalesAidStepIds.CONFIGUREMESSAGE),
            path: isCompleted(SalesAidStepIds.CONFIGUREMESSAGE) ? "/MessageSelectionPage" : ""
        },
        {
            id: SalesAidStepIds.GENERATEDOCUMENT,
            label: getConfigValue(appState.config?.Focus?.BreadCrumb?.Generate?.Label, appState)?.Value || null,
            current: isCurrent(SalesAidStepIds.GENERATEDOCUMENT),
            completed: isCompleted(SalesAidStepIds.GENERATEDOCUMENT),
            path: ""
        }
    ];

    function isCompleted(stepId){
        const currentIndex = stepsOrder.indexOf(currentStepId);
        const stepIndex = stepsOrder.indexOf(stepId);

        return stepIndex < currentIndex;
    }

    function isCurrent(stepId){
        const currentIndex = stepsOrder.indexOf(currentStepId);
        const stepIndex = stepsOrder.indexOf(stepId);

        return stepIndex === currentIndex;
    }

    const orderdSteps = steps.toSorted((a,b) => 
        stepsOrder.indexOf(a.id) - stepsOrder.indexOf(b.id)
    );

    return (
        <StepProgreassBar
            title={getConfigValue(appState.config?.Focus?.Header, appState)?.Value || null}
            steps={orderdSteps}
        />
    );
}

export default CreateSalesAidStepProgressBar;